import { TIMER_STATUS } from '../../../../../../../types/enum';

const CurrentState = ({ status, defaultState }) => {
  return (
    <div className='text-center text-xl'>
      {status === TIMER_STATUS.PREP || status === TIMER_STATUS.READY
        ? 'Get Ready!'
        : status === TIMER_STATUS.DONE
        ? 'Workout Completed!'
        : status === TIMER_STATUS.REST
        ? 'Rest'
        : status === TIMER_STATUS.SET_REST
        ? 'Set Rest'
        : status === TIMER_STATUS.CYCLE_REST
        ? 'Cycle Rest'
        : status === TIMER_STATUS.PAUSE
        ? 'Paused'
        : defaultState}
    </div>
  );
};

const AddTime = ({ status, pausedAt, onClick }) => {
  return (
    <div className='w-16 text-center'>
      {status === TIMER_STATUS.REST ||
      status === TIMER_STATUS.SET_REST ||
      status === TIMER_STATUS.CYCLE_REST ||
      (status === TIMER_STATUS.PAUSE && pausedAt === TIMER_STATUS.REST) ||
      (status === TIMER_STATUS.PAUSE && pausedAt === TIMER_STATUS.SET_REST) ||
      (status === TIMER_STATUS.PAUSE &&
        pausedAt === TIMER_STATUS.CYCLE_REST) ? (
        <button
          className='border rounded-full py-2 w-full'
          onClick={onClick}
        >
          + 15s
        </button>
      ) : null}
    </div>
  );
};

const Timer = ({
  status,
  pausedAt,
  handleAddRestTime,
  getViewTimeFormat,
  runPrepTime,
  runExerciseTime,
  runExerciseReps,
  runRestTime,
  runSetRestTime,
  runCycleRestTime,
  totalRanTime,
  currentExercise,
}) => {
  return (
    <div className='flex justify-center items-center font-bold h-1/6 mb-2'>
      <div className='w-full'>
        <CurrentState
          status={status}
          defaultState={currentExercise?.name}
        />
        <div className='flex justify-between items-center px-2'>
          <AddTime
            status={status}
            pausedAt={pausedAt}
            onClick={handleAddRestTime(15)}
          />
          <div className='text-6xl'>
            {status === TIMER_STATUS.PREP || status === TIMER_STATUS.READY ? (
              getViewTimeFormat(runPrepTime)
            ) : status === TIMER_STATUS.EXERCISE &&
              currentExercise?.mode === 'TIME' ? (
              getViewTimeFormat(runExerciseTime)
            ) : status === TIMER_STATUS.EXERCISE &&
              currentExercise?.mode === 'REPS' ? (
              <>x {runExerciseReps}</>
            ) : status === TIMER_STATUS.REST ? (
              getViewTimeFormat(runRestTime)
            ) : status === TIMER_STATUS.SET_REST ? (
              getViewTimeFormat(runSetRestTime)
            ) : status === TIMER_STATUS.CYCLE_REST ? (
              getViewTimeFormat(runCycleRestTime)
            ) : status === TIMER_STATUS.PAUSE &&
              pausedAt === TIMER_STATUS.PREP ? (
              getViewTimeFormat(runPrepTime)
            ) : status === TIMER_STATUS.PAUSE &&
              pausedAt === TIMER_STATUS.EXERCISE ? (
              getViewTimeFormat(runExerciseTime)
            ) : status === TIMER_STATUS.PAUSE &&
              pausedAt === TIMER_STATUS.REST ? (
              getViewTimeFormat(runRestTime)
            ) : status === TIMER_STATUS.PAUSE &&
              pausedAt === TIMER_STATUS.SET_REST ? (
              getViewTimeFormat(runSetRestTime)
            ) : status === TIMER_STATUS.PAUSE &&
              pausedAt === TIMER_STATUS.CYCLE_REST ? (
              getViewTimeFormat(runCycleRestTime)
            ) : (
              getViewTimeFormat(totalRanTime)
            )}
          </div>
          <div className='w-16'></div>
        </div>
      </div>
    </div>
  );
};

export default Timer;
